var map = {
	"./tab-category-active.png": "038b",
	"./tab-goods-active.png": "7547",
	"./tab-mall-active.png": "030f",
	"./tab-salesSlip-active.png": "f579",
	"./tab-salespromotion-active.png": "4e8b",
	"./tab-salesstatistics-active.png": "61d3",
	"./tab-shelf-active.png": "cc54",
	"./tab-shopcar-active.png": "e449",
	"./tab-workbench-active.png": "7e0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40d56";